<div class="modal-header">
  <h4 class="modal-title">Message Agency</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('cancel')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="form-group">
    <div class="modal-">Call 911 for a medical emergency. Message <strong>{{agencyName}}</strong> with
      concerns, questions or account updates.
    </div>
    <hr/>
    <label for="messageType">Type of message</label>
    <select class="custom-select" [(ngModel)]="patientMessage.messageType" name="messageType" id="messageType">
      <option value="account_update" selected="selected">Account Update</option>
      <option value="medical_concern">Medical Concern</option>
      <option value="agency_question">Agency Question</option>
      <option value="other">Other</option>
    </select>
  </div>
  <label for="message">Message</label>
  <div class="form-group">
    <textarea class="form-control" name="message" rows="10" [(ngModel)]="patientMessage.messageBody" id="message"
              [ngClass]="{'is-invalid': errorMessage}"
              placeholder="Enter message"
              required></textarea>
    <div *ngIf="errorMessage" class="invalid-feedback">
      {{errorMessage}}
    </div>
  </div>

</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="modal.dismiss('cancel')">Discard Message</button>
  <button type="button" class="btn btn-primary" (click)="sendRequest()">Send Message</button>
</div>

